import { render } from "./LogoDark.vue?vue&type=template&id=315ce79e"
const script = {}

import exportComponent from "/home/miras_zxc/vc-remote/_work/verification-center-front/verification-center-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__